<template>
  <section
    v-if="spaceId"
    class="c-ad-section u-text-center"
    :class="{ 'is-empty': isEmpty }"
  >
    <v-ad-banner
      ref="adContainer"
      :ad-system="adSystem"
      :slot-params="slotParams"
      :space-id="spaceId"
      @isEmpty="setIsEmpty"
    ></v-ad-banner>
  </section>
</template>
<script>
  import { AdSystem } from '@/shared/enums';
  import VAdBanner from '../ad-banner/index.vue';

  export default {
    components: {
      VAdBanner,
    },
    enums: {
      AdSystem,
    },
    inject: ['$section'],
    data() {
      return {
        isEmpty: true,
      };
    },
    computed: {
      adSystem() {
        return this.$section.resource.configuration.adSystem?.toUpperCase();
      },
      spaceId() {
        const slotParams = this.slotParams;

        const slid = slotParams ? Object.fromEntries(
          slotParams
            .split('&')
            .map((record) => record.split('=')) || [],
        ).slid : null;

        return this.$section.resource.configuration?.spaceIdWeb || this.$section.resource.configuration?.spaceId || slid;
      },
      slotParams() {
        const slotParams = this.$section.resource.configuration?.slotParams;

        if (typeof slotParams === 'object') {
          return this.getAdjustedSlotParams(slotParams);
        }

        return slotParams;
      },
    },
    methods: {
      getAdjustedSlotParams(slotParams) {
        if (!slotParams) {
          return '';
        }

        const params = this.$window.isSmallAdView ? slotParams.small : slotParams.big;
        const dpr = window.devicePixelRatio;

        return `${params}&_fw_dpr=${dpr}`;
      },
      setIsEmpty(value) {
        this.isEmpty = value;
        this.$emit('isEmpty', value);
      },
    },
  };
</script>
